module.exports = __webpack_public_path__ + "img/gw28801.d126e37f.png";